import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=72b36e6b&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=72b36e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b36e6b",
  null
  
)

export default component.exports